import { Button, ConfigProvider, Popover, Form, FormProps, Alert } from "antd";
import { FeedbackForm } from "./FeedbackForm";
import { useState, useEffect } from "react";
import { apiRequest } from "@vojomo-core/shared/src/api";
import { useDatadog } from "../../hooks/use-datadog";
import { useGlobal } from "../../hooks/use-global";

export const Feedback = () => {
  const { isMobile } = useGlobal();
  type FieldType = {
    type?: string;
    severity?: string;
    message?: string;
  };

  const [form] = Form.useForm<FieldType>();
  const { trackEvent, trackError } = useDatadog();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (showAlert) {
      timeoutId = setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [showAlert]);

  const onFinish: FormProps<FieldType>["onFinish"] = async (values) => {
    // TODO: Send feedback to backend
    try {
      trackEvent("sending_feedback", { values });

      await apiRequest({
        subRoute: "feedback",
        path: "/",
        method: "POST",
        body: values
      });
      // Close popover
      setIsPopoverOpen(false);

      // Reset form
      form.resetFields();

      // Popup success message
      setShowAlert(true);
    } catch (error) {
      trackError("error_posting_feedback", error, { values });
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "rgb(64, 41, 117)", // 20 pxs lighter
            defaultBorderColor: "rgb(44, 21, 97)",
            defaultBg: "rgb(44, 21, 97)",
            defaultHoverBg: "rgb(64, 41, 117)" // 20 pxs lighter
          }
        }
      }}
    >
      {showAlert ? (
        <Alert
          message="Success"
          description="Your feedback has been submitted successfully and received."
          type="success"
          showIcon
          banner
          closable
          onClose={() => setShowAlert(false)}
          style={{
            bottom: isMobile ? 20 : 50,
            position: "fixed",
            right: isMobile ? 12 : 100,
            left: isMobile ? 12 : "auto",
            zIndex: 1000
          }}
        />
      ) : (
        <Popover
          trigger="click"
          arrow={false}
          placement={isMobile ? "top" : "topLeft"}
          content={FeedbackForm({ form, onFinish, isMobile })}
          open={isPopoverOpen}
          onOpenChange={setIsPopoverOpen}
        >
          <Button
            style={{ color: "white" }}
            className={isMobile ? "min-h-touch" : ""}
          >
            Feedback
          </Button>
        </Popover>
      )}
    </ConfigProvider>
  );
};
